module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/HR-6461d333865dd74167db295545d77461.png";